module.exports = __webpack_public_path__ + "static/zelt4-8f4a7c096fe98a1041ac06fdc6472111.jpg";